import { twJoin } from 'tailwind-merge';
import { tv } from 'tailwind-variants';

export const useShowPasswordButtonStyles = () => {
  return {
    showPasswordButtonStyle: tv({
      base: twJoin(
        'absolute top-1/2 -translate-y-1/2 right-5',
        'transition-colors duration-300',
        'text-gray-400 rounded-full',
        'outline-none',
        'hover:text-primary focus:text-primary',
      ),
    }),

    eyeIconStyle: tv({
      base: twJoin('transition-all duration-300'),
      variants: {
        visible: {
          true: '',
          false: 'hidden',
        },
      },
      defaultVariants: {
        visible: true,
      },
    }),
  };
};
